import React from "react";
import Logo from "./FlowentiIcon";
import GradualSpacing from "./GradualSpacing";
import { Box } from "@mui/material";

const FlowentiLoader: React.FC = () => {
    return (
        <React.Fragment>
            <style>
                {`
          .loader {
            overflow: visible;
            height: fit-content;
            width: fit-content;
            padding: 0px;
            display: flex;
          }

          .logo {
            fill: none;
            stroke-dasharray: 80px;
            /*<-- Play with this number until it look cool */
            stroke: black;
            animation: load 15s infinite linear;
          }

          @keyframes load {
            0% {
              stroke-dashoffset: 0px;
            }

            100% {
              stroke-dashoffset: 200px;
              /* <-- This number should always be 10 times the number up there*/
            }
          }
        `}
            </style>
            <Box sx={{ height: "100dvh", width:"100vw", display:"flex", justifyContent:"center", alignItems:"center"}}>
                <Box sx={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                    <div className="loader">
                        <Logo filled={false} className="logo" />
                    </div>
                    <GradualSpacing
                        duration={1}
                        text="FLOWENTI"
                        style={{color:"#1e355f", fontWeight:800, textAlign:"center", fontSize:"2.25rem", lineHeight:"2.5rem", letterSpacing:"-0.1em" }}
                    />
                </Box>
            </Box>
        </React.Fragment>
    );
};

export default FlowentiLoader;